import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import AssignmentIcon from '@mui/icons-material/Assignment';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import { styled, useTheme } from '@mui/material/styles';
import React from 'react';
import PropTypes from 'prop-types';

// import CustomButton from './CustomButton';

import showcases from '../content/showcases';
import { trackEvent } from '../modules/matomo';

const NavIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  background: theme.palette.background.paper,
  boxShadow: `0 0 10px 5px ${theme.palette.divider}`,
  transition: 'box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out',
  '&:focus, &:hover': {
    background: theme.palette.background.paper,
    boxShadow: `0 0 6px 3px ${theme.palette.background.brand}`,
    [theme.breakpoints.up('md')]: {
      top: '50%',
      boxShadow: `0 0 15px 7px ${theme.palette.background.brand}`,
    },
    transform: 'translateY(-50%) scale(1.05)',
  },
}));

const ChipContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginTop: theme.spacing(4),
  justifyContent: 'center',
}));

const ShowcaseSelector = styled(ButtonBase)(({ theme }) => ({
  width: 24,
  height: 24,
  borderRadius: '50%',
  '&::before': {
    width: 10,
    height: 10,
    borderRadius: '50%',
    background: theme.palette.divider,
    content: '""',
    transition: 'background 0.3s ease-in-out, transform 0.3s ease-in-out',
  },
  '&[aria-pressed="true"]::before': {
    background: theme.palette.text.primary,
  },
  '&:hover::before, &:focus-visible::before': {
    transform: 'scale(1.3)',
  },
}));

const ShowCase = ({ type = false }) => {
  const theme = useTheme();
  const [count, setCount] = React.useState(0);
  const filteredShowcases = type ? showcases.filter(s => s.type === type) : showcases;
  const showcase = filteredShowcases.length ? filteredShowcases[count] : {};
  
  const handleNext = () => {
    setCount((prev) => (prev + 1) % filteredShowcases.length);
    trackEvent('Showcase', 'Nächste Fallstudie', `ShowCase ${type || 'Home'}`);
  };

  const handlePrev = () => {
    setCount((prev) => (prev - 1 + filteredShowcases.length) % filteredShowcases.length);
    trackEvent('Showcase', 'Vorherige Fallstudie', `ShowCase ${type || 'Home'}`);
  };
  
  return (
    <Box className="content center" sx={{
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.spacing(2),
      background: theme.palette.background.default,
      boxShadow: `0 0 20px 10px ${theme.palette.divider}`,
      padding: theme.spacing(4),
      position: 'relative',
      h2: {
        fontSize: '1.2em',
        [theme.breakpoints.up('md')]: {
          fontSize: 'max(1.5em, 2vw)',
        },
      },
    }}>
      {filteredShowcases.length > 1 ? (
        <NavIconButton
          aria-label="Vorherige Fallstudie"
          onClick={handlePrev}
          sx={{
            left: 0,
            [theme.breakpoints.up('md')]: {
              left: '-5vw',
            },
          }}
        >
          <ArrowBackIcon sx={{ fontSize: '5vw' }} />
        </NavIconButton>
      ) : null}
      {filteredShowcases.length > 1 ? (
        <NavIconButton
          aria-label="Nächste Fallstudie"
          onClick={handleNext}
          sx={{
            right: 0,
            [theme.breakpoints.up('md')]: {
              right: '-5vw',
            },
          }}
        >
          <ArrowForwardIcon sx={{ fontSize: '5vw' }} />
        </NavIconButton>
      ) : null}
      <Box
        id="showcase-content"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        <h2>{showcase.title}</h2>
        <p dangerouslySetInnerHTML={{ __html: showcase.description }} />
        <ChipContainer>
          {showcase.kpis?.map((kpi, index) => (
            <Chip key={index} label={kpi.label} variant="outlined" />
          ))}
        </ChipContainer>
      </Box>
      {/* <CustomButton
        onClick={() => console.log('open showcase '+ showcase.title)}
        startIcon={<AssignmentIcon />}
        sx={{
          background: theme.palette.background.paper,
          marginTop: '2rem',
        }}
      >
        Mehr erfahren
      </CustomButton> */}
      {filteredShowcases.length > 1 ? (
        <Box sx={{
          position: 'absolute',
          bottom: '-2rem',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: theme.spacing(1),
        }}
        role="group"
        aria-label="Fallstudie auswählen"
        >
          {filteredShowcases.map((item, index) => (
            <ShowcaseSelector
              key={index}
              aria-controls="showcase-content"
              aria-label={`Fallstudie ${index + 1}: ${item.title} anzeigen`}
              aria-pressed={index === count}
              onClick={() => setCount(index)}
            />
          ))}
        </Box>
      ) : null}
    </Box>
  );
};

ShowCase.propTypes = {
  type: PropTypes.string,
};

export default ShowCase;
